"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ReadingPaneQuick_1 = require("./components/ReadingPaneQuick");
var ReadingPaneFull_1 = require("./components/ReadingPaneFull");
var discardReadingPaneOption_1 = require("./actions/discardReadingPaneOption");
var saveReadingPaneOption_1 = require("./actions/saveReadingPaneOption");
var isReadingPaneOptionDirty_1 = require("./utils/isReadingPaneOptionDirty");
var ReadingPaneOption = {
    key: 'readingPane',
    titleStringKey: 'optionTitle_readingPane',
    searchTermsStringKey: 'optionTitle_readingPane',
    fullOptionFormSettings: {
        render: function () { return React.createElement(ReadingPaneFull_1.default, null); },
        isDirty: isReadingPaneOptionDirty_1.default,
        onSave: saveReadingPaneOption_1.saveReadingPaneOptionFull,
        onDiscard: discardReadingPaneOption_1.default,
    },
    quickOptionSettings: {
        rendering: {
            render: function (props) { return (React.createElement(ReadingPaneQuick_1.default, tslib_1.__assign({}, props))); },
        },
        order: 2 /* ReadingPane */,
        workloads: 1 /* Mail */,
        customTitle: 'options_readingPane_quickSetting_label',
    },
};
exports.default = ReadingPaneOption;
//# sourceMappingURL=ReadingPaneOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-reading-pane-option/lib/ReadingPaneOption.js
// module id = 5113
// module chunks = 2